
/** --------------------------------------------------------------------------------------------------
 * 開啟'確認刪除'視窗
 *
 *
 * @param message 要顯示的訊息
 * @param btn_yes 要顯示在 yes/ok 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param btn_no  要顯示在 no/cancel 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param title   標題文字
 * @param observer function 當使用者點選'是'或'否'後,會呼叫的 function;
 *                 使用者點選'btn_yes'會回傳 true;
 *                 使用者點選'btn_no'會回傳 false;
 * @param type    類型 "warning", "error", "success" , "info"
 *
 * -------------------------------------------------------------------------------------------------- */
window.confirmDialog = function({
        message = '發生錯誤，請重整頁面後再試一次。',
        btn_yes = "確定",
        btn_no = null,
        title = null,
        observer = null
    } = {}) {

    let   dialog = null;
    const hideDialog = (isOkay) => {
                            dialog.hide();
                            unlockScroll($('html body'));
                            if (observer) observer(isOkay);
                        }

    // 顯示在 'top' 中的 dialog
    if (btn_no != null) {
        dialog = $('.rd_message_div')
        dialog.find('.rd_btn_cancel').text(btn_no)

        // 移除之前的綁定事件
        dialog.find('.rd_btn_ok'    ).off('click');
        dialog.find('.rd_btn_cancel').off('click');

        // 新增點擊事件
        dialog.find('.rd_btn_ok').on('click', function () {
            hideDialog(true)
        });

        dialog.find('.rd_btn_cancel').on('click', function () {
            hideDialog(false)
        });
    } else {
        dialog = $('.rd_msg_div')

        // 移除之前的綁定事件
        dialog.find('.rd_btn_ok').off('click');

        // 新增點擊事件
        dialog.find('.rd_btn_ok').on('click', function () {
            hideDialog(true)
        });
    } // end of if


    // 移除之前的綁定事件
    dialog.find('.rd_close').off('click');

    // 新增點擊事件
    dialog.find('.rd_close').on('click', function () {
        hideDialog(false)
    });

    // 顯示文字
    dialog.find('.rd_btn_ok' ).text(btn_yes)
    dialog.find('.rd_title'  ).text(title ?? '系統訊息')
    dialog.find('.rd_message').text(message ?? '系統訊息')

    // 顯示 dialog
    dialog.fadeIn()

    lockScroll($('html body'))
}
